import React, { Component } from 'react';
import TwitterContainer from '../social/twitter';
import Facebook from '../social/facebook';

export default class VistoRedes extends Component {


    render() {
        return ( 
            <div className="gray-bg-semi-dark ">
                <div className="boletin__section">
                    <div className="boletin__section market__section">
                        <div className="gray-bg-semi-dark " id="visto-redes" >
                            <div className="boletin__section">
                                <div className="row boletin__title-row">
                                    <div className="col-sm-12  boletin__title-name-section">
                                        <span className=" boletin__title-name">VISTO EN REDES</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="social-network__section">
                                            <div className="social-network__header">Tweets <span className="social-network__icon"><i className="fab fa-twitter"></i></span></div>
                                            <div className="social-network__body">
                                                <TwitterContainer></TwitterContainer>
                                            </div> 
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="social-network__section">
                                            <div className="social-network__header">Facebook <span className="social-network__icon"><i className="fab fa-facebook"></i></span></div>
                                            <div className="social-network__body">
                                                <div className="social-network__comment social-network__tweet ">
                                                    <Facebook></Facebook>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="social-network__section heightSocial" >
                                            <div className="social-network__header">Linkedin <span className="social-network__icon"><i className="fab fa-linkedin"></i></span></div>
                                            <div className="social-network__body">
                                                <div className="social-network__comment social-network__tweet ">
                                                    
                                                </div>
                                            </div>
                                        </div> */}

                                    </div>       
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}